/** @format */

import handleInputError from './handle_input_error';
import {Textarea} from '@/components/ui/textarea';
import handleError from './handle_error';
import React from 'react';

/**
 * Wrap an input with our input error handler
 * Meant to be as flexible and transparent as possible
 * Steps for usage.
 * <InputWithErrorHandler
 *    className="form-control"
 *    type="text"
 *    error={props.error}
 *    errorPath="company"
 *    value={props.company || ''}
 *    onChange={props.onInputChange.bind(this, 'user.company')}
 * />
 * Import this component and give it all the normal values you would for an input but also add
 * error - This is the error object that contains the messages for fields {'user_detail': { 'text_number' : {'_empty':'hey! do not leave me empty'}}}
 * errorPath - This will look for the error at that endpoint. So for user_detail text_number error, you would pass user_detail.text_number
 */
export default handleError(
    handleInputError(function TextAreaWithErrorHandler({
        className,
        hasError,
        errorMessage,
        onChangeValue,
        style,
        ...inputProps
    }) {
        if (hasError) {
            if (className && className.length > 0) {
                className = className.split(' ');
            } else {
                className = [];
            }
            className.push('is-invalid');
            inputProps.className = className.join(' ');
        } else {
            inputProps.className = className;
        }
        const _getErrorFeedback = (hasError, errorMessage) => {
            if (hasError) {
                return (
                    <div style={{fontSize: '.9em', color: 'red', display: 'block'}}>
                        {errorMessage}
                    </div>
                );
            }

            return;
        };

        let onChange = onChangeValue
            ? ({target: {value}}) => onChangeValue(value)
            : inputProps.onChange;

        return (
            <React.Fragment>
                {_getErrorFeedback(hasError, errorMessage)}
                <Textarea {...inputProps} onChange={onChange} />
            </React.Fragment>
        );
    })
);
